<template>
  <div>
    <div v-if="company">
      <h4>Details for {{ company.name }}</h4>
      <b-form>
        <company-logo :company="company"></company-logo>
        <hr />
        <b-form-group label="Company Name">
          <b-form-input id="name" v-model="company.name">{{
            company.name
          }}</b-form-input>
        </b-form-group>
        <b-form-group label="Business Category">
          <b-form-input
            v-model="company.category"
            placeholder="Set a category for this company"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Subscription Type">
          <b-form-input
            v-model="company.subscriptionType"
            placeholder="Set a subscription type for this company"
          ></b-form-input>
        </b-form-group>
        <!-- <b-form-group label="Contract Start Date">
          <epoch-datetime-picker
            v-model="company.contractStartEpoch"
          ></epoch-datetime-picker>
        </b-form-group> -->
        <b-form-group label="Contract End Date" v-if="!company.isVendor" :key="endEpochKey">
          <!-- v-model="company.contractEndEpoch" -->
          <epoch-datetime-picker
            :value="company.contractEndEpoch"
            @input="setEndEpoch"
          ></epoch-datetime-picker>
        </b-form-group>
        <!--
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle.logo-accordion variant="outline-primary">Logo</b-button>
          </b-card-header>
          <b-collapse id="logo-accordion" role="tabpanel">
            <b-card-body class="text-center">
              <div class="p=2">
                <input type="file" class="form-control-file" @change="(e) => uploadImage(e)" />
              </div>
              <div v-if="company.activeLogo">
                <img
                  :src="'https://s3.us-east-2.amazonaws.com/panelvue-photos/logo/' + company.activeLogo.uuid"
                  class="logo"
                />
              </div>
              <div v-else>
                <img class="logo" src="/no-logo.png" />
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
        -->
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              href="#"
              v-b-toggle.billing-address-accordion
              variant="outline-primary"
              class="dropdown-button"
              >Billing Address</b-button
            >
          </b-card-header>
          <b-collapse id="billing-address-accordion" role="tabpanel">
            <b-card-body>
              <b-form-group>
                <label for="street">Street</label>
                <b-form-input id="street" v-model="company.street">{{
                  company.street
                }}</b-form-input>
              </b-form-group>
              <b-form-group>
                <label for="city">City</label>
                <b-form-input id="city" v-model="company.city">{{
                  company.city
                }}</b-form-input>
              </b-form-group>
              <b-form-group>
                <label for="state">State</label>
                <b-form-input id="state" v-model="company.state">{{
                  company.state
                }}</b-form-input>
              </b-form-group>
              <b-form-group>
                <label for="zip">Zip Code</label>
                <b-form-input id="zip" v-model="company.zip">{{
                  company.zip
                }}</b-form-input>
              </b-form-group>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              href="#"
              v-b-toggle.shipping-address-accordion
              variant="outline-primary"
              class="dropdown-button"
              >Shipping Address</b-button
            >
          </b-card-header>
          <b-collapse id="shipping-address-accordion" role="tabpanel">
            <b-card-body>
              <b-form-group>
                <label for="shipping_street">Street</label>
                <b-form-input
                  id="shipping_street"
                  v-model="company.shipping_street"
                  >{{ company.shipping_street }}</b-form-input
                >
              </b-form-group>
              <b-form-group>
                <label for="shipping_city">City</label>
                <b-form-input
                  id="shipping_city"
                  v-model="company.shipping_city"
                  >{{ company.shipping_city }}</b-form-input
                >
              </b-form-group>
              <b-form-group>
                <label for="shipping_state">State</label>
                <b-form-input
                  id="shipping_state"
                  v-model="company.shipping_state"
                  >{{ company.shipping_state }}</b-form-input
                >
              </b-form-group>
              <b-form-group>
                <label for="shipping_zip">Zip Code</label>
                <b-form-input
                  id="shipping_zip"
                  v-model="company.shipping_zip"
                  >{{ company.shipping_zip }}</b-form-input
                >
              </b-form-group>
            </b-card-body>
          </b-collapse>
        </b-card>
        <div class="spreadsheets-container text-center py-2">
          <button
            class="btn btn-primary w-25"
            @click.prevent="activeModal = consts.ALL_NODES_SPREADSHEET"
          >
            All Node Data Spreadsheet
          </button>
          <button
            class="btn btn-primary w-25 ml-3"
            @click.prevent="activeModal = consts.INVOICE_SPREADSHEET"
          >
            Invoice Info Spreadsheet
          </button>
        </div>
        <hr />
        <div class="py-2">
          Company admins:
          <span v-if="!company.users || !company.users.length">None<br /></span>
          <v-list two-line subheader v-else>
            <template v-for="(user, i) in company.users">
              <v-list-item :key="`user-${user.id}`">
                <v-list-item-content>
                  <v-list-item-title>
                    <FullName :user="user" />
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-avatar v-if="user.photoId">
                  <v-img
                    :src="`${$store.state.basePhotoUrl}profile/${user.photoId}`"
                    fit="contain"
                  ></v-img>
                </v-list-item-avatar>
              </v-list-item>
              <v-divider
                v-if="i < company.users.length - 1"
                :key="i"
              ></v-divider>
            </template>
          </v-list>
          <button
            class="btn btn-primary"
            @click.prevent="
              () => {
                admin = {};
                activeModal = 'add-admin';
                addAdminError = '';
              }
            "
          >
            Add Admin Account
          </button>
        </div>
        <hr />
        <loading-panel :loading="loading">
          <button class="btn btn-primary w-25 py-2" @click.prevent="save">
            Save
          </button>
        </loading-panel>
      </b-form>
    </div>
    <div v-else>Please select a company.</div>
    <modal-container v-if="activeModal === consts.ALL_NODES_SPREADSHEET">
      <all-nodes-spreadsheet
        @done="activeModal = null"
        :company="company"
      ></all-nodes-spreadsheet>
    </modal-container>
    <modal-container v-if="activeModal === consts.INVOICE_SPREADSHEET">
      <invoice-spreadsheet
        @done="activeModal = null"
        :company="company"
      ></invoice-spreadsheet>
    </modal-container>
    <modal-container v-if="activeModal === 'add-admin'">
      <v-toolbar-title>Assign New Admin Account</v-toolbar-title>
      <v-form>
        <v-text-field label="First name" v-model="admin.firstName" />
        <v-text-field label="Last name" v-model="admin.lastName" />
        <v-text-field label="Email address" v-model="admin.email" />
      </v-form>
      <error-panel class="m-auto" :errors="[addAdminError]"></error-panel>
      <v-card-actions>
        <v-progress-circular indeterminate v-if="addAdminLoading" />
        <template v-else>
          <button class="btn btn-primary" @click.prevent="activeModal = null">
            Cancel
          </button>
          <v-spacer />
          <button class="btn btn-primary" @click.prevent="addAdmin">
            Submit
          </button>
        </template>
      </v-card-actions>
    </modal-container>
    <error-panel class="m-auto" :errors="errors"></error-panel>
  </div>
</template>

<script>
import EpochDatetimePicker from "@/components/EpochDatetimePicker";
import ModalContainer from "@/components/ModalContainer";
import AllNodesSpreadsheet from "@/components/AllNodesSpreadsheet";
import InvoiceSpreadsheet from "@/components/InvoiceSpreadsheet";
import CompanyLogo from "@/components/CompanyLogo";
import FullName from "@/components/FullName";
import XLSX from "xlsx";

const consts = {
  ALL_NODES_SPREADSHEET: "ALL_NODES_SPREADSHEET",
};

export default {
  name: "company",
  components: {
    EpochDatetimePicker,
    ModalContainer,
    AllNodesSpreadsheet,
    InvoiceSpreadsheet,
    CompanyLogo,
    FullName,
  },
  props: {
    company: {
      default: () => ({
        contractEndEpoch: null,
      }),
    },
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    activeModal: "",
    consts: consts,

    endEpochKey: 0,

    admin: {},
    addAdminLoading: false,
    addAdminError: "",
  }),
  mounted() {
    // if (this.company)
  },
  watch: {
    company: {
      handler(newValue) {
        // was used for debug
      },
      deep: true,
    },
  },
  methods: {
    setEndEpoch(val) {
      if (Number.isNaN(val)) return;
      this.company.contractEndEpoch = val;
      this.endEpochKey = new Date().getTime();
    },
    uploadImage(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.company.file = files[0];
    },
    async spreadsheet() {
      try {
        this.loading = true;
        const response = await this.$web.generateSpreadsheet(this.company);
        let data = response.data;

        var workbook = XLSX.utils.book_new();
        for (let i = 0; i < data.length; i++) {
          // make a sheet for each location
          // list the node types for each location
          let datum = data[i];
          var ws_data = [
            ["panels", datum.panels],
            ["mccs", datum.mccs],
            ["vfds", datum.vfds],
            ["breakers", datum.breakers],
            ["starters", datum.starters],
            ["softstarts", datum.softstarts],
            ["auxnodes", datum.auxnodes],
            ["switchboards", datum.switchboards],
            ["distribution panelboards", datum.dps],
            ["transformers", datum.transformers],
            ["disconnects", datum.disconnects],
            ["fuses", datum.fuses],
          ];
          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          XLSX.utils.book_append_sheet(workbook, ws, datum.location);
        }

        let wopts = { bookType: "xlsx", bookSST: false, type: "binary" };
        XLSX.writeFile(workbook, this.company.name + ".xlsx", wopts);
      } catch (err) {
        console.log(err);
        this.errors = ["An error occurred."];
      } finally {
        this.loading = false;
      }
    },
    async save() {
      try {
        this.loading = true;
        const response = await this.$web.updateCompany(this.company);
        this.company.contractStartEpoch =
          response.data.company.contractStartEpoch;
        this.company.contractEndEpoch = response.data.company.contractEndEpoch;
        this.company.activeLogo = response.data.company.activeLogo;
      } catch (err) {
        console.log(err);
        this.errors = ["An error occurred."];
      } finally {
        this.loading = false;
      }
    },
    async addAdmin() {
      try {
        this.addAdminLoading = true;
        const response = await this.$web.addAdmin(this.admin, this.company.id);

        this.company.users.push(response.data.user);
        this.activeModal = null;
      } catch (err) {
        console.log(err);
        if (err.response && err.response.data.err) {
          this.addAdminError = err.response.data.err;
        } else {
          this.addAdminError = "An error occurred.";
        }
      } finally {
        this.addAdminLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.logo {
  height: 100px;
}

.spreadsheets-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

input {
  box-sizing: border-box !important;
}

.vdatetime-input {
  box-sizing: border-box;
  width: 50px;
}

.dropdown-button {
  box-sizing: border-box;
  display: block;
  width: 100%;
}
</style>
